import { defineStore } from 'pinia'

import { useFilterOptionsStore } from '@/stores/FilterOptionsStore'

export const useSelectedFiltersStore = defineStore('SelectedFilters', {
    state: () => ({ 
        modifiers: {},
        selectedFilters: {},
    }),
    getters: {
        //
    },
    actions: {
        // modifiers
        registerModifier(key, modifier = 'AND') {
            this.modifiers[key] = modifier;
        },
        registerModifiers(keys, modifier = 'AND') {
            keys.forEach((key) => {
                this.modifiers[key] = modifier;
            });
        },
        getModifiers() {
            return this.modifiers;
        },
        setModifier(key, modifier) {
            this.modifiers[key] = modifier;
        },

        // selectedFilters
        registerFilters(keys) {
            keys.forEach((key) => {
                this.selectedFilters[key] = {};
            });
        },
        registerFilter(key, options) {
            let filterState = {};
            Object.keys(options).forEach((indexOption) => {
                filterState[indexOption] = false;
            });
            Object.entries(options).forEach(([key, value]) => {
                filterState[value.id] = false;
            });

            this.selectedFilters[key] = filterState;
            console.log(this.selectedFilters);
        },
        getKeys() {
            return Object.keys(this.selectedFilters);
        },
        getActiveFilters() {
            let selectedFilters = this.selectedFilters;
            selectedFilters = Object.entries(selectedFilters).map(([filterIndex, filterOptions]) => {
                return [
                    filterIndex,
                    Object.entries(filterOptions)
                        .filter(([key, value]) => {
                            return value == true;
                        })
                        .map(([filterIndex, filterOptions]) => {
                            return (filterIndex);
                        })
                ];
            });

            return Object.fromEntries(selectedFilters);
        },
        getActiveFiltersWithName() {
            const FilterOptionsStore = useFilterOptionsStore();

            let selectedFilters = this.selectedFilters;
            selectedFilters = Object.entries(selectedFilters).map(([filterIndex, filterOptions]) => {
                let options = FilterOptionsStore.getFlattenOptions(filterIndex);
                let selected = Object.entries(filterOptions)
                    .filter(([key, value]) => {
                        return value == true;
                    })
                    .map(([filterIndex, filterOptions]) => {
                        return (filterIndex);
                    });

                return options.filter(option => selected.includes(option.id)).map(option => option.value);
            });

            return selectedFilters.flat();
        },
        getActiveFiltersCount(key = null) {
            let selectedFilters = this.selectedFilters;

            if (key) {
                if (Object.hasOwn(selectedFilters, key)) {
                    selectedFilters = Object.values(selectedFilters[key]);
                } else {
                    return 0;
                }
            } else {
                selectedFilters = Object.values(selectedFilters).map(keyFilters => Object.values(keyFilters)).flat();
            }

            return selectedFilters.filter(filterValue => filterValue === true).length;
        },
        changeState(key, index) {
            let state = this.selectedFilters[key][index] || false;

            this.setState(key, index, !state);
        },
        setState(key, index, state) {
            this.selectedFilters[key][index] = state;
        },
        resetFilters() {
            Object.keys(this.selectedFilters).forEach((filter) => {
                Object.keys(this.selectedFilters[filter]).forEach((index) => {
                    this.selectedFilters[filter][index] = false;
                });
            });
        },
    },
})